import { Pill } from '@endaoment-frontend/ui/shared';

import styles from './DoubleFeature.module.scss';
import { DoubleFeatureProps } from './DoubleFeature.types';

export const DoubleFeature = ({
  pillLeft,
  pillRight,
  headerLeft,
  headerRight,
  extraLeft,
  extraRight,
}: DoubleFeatureProps) => {
  return (
    <section className={styles['double-feature']}>
      <div>
        <Pill size="large" variation="orange">
          {pillLeft}
        </Pill>
        <h3>{headerLeft}</h3>
        {extraLeft && (
          <>
            <br />
            <span>{extraLeft}</span>
          </>
        )}
      </div>
      <div>
        <Pill size="large" variation="blue">
          {pillRight}
        </Pill>
        <h3>{headerRight}</h3>
        {extraRight && (
          <>
            <br />
            <span>{extraRight}</span>
          </>
        )}
      </div>
    </section>
  );
};
